import { render, staticRenderFns } from "./Departamentos.vue?vue&type=template&id=7bfa7f8e&scoped=true"
import script from "./Departamentos.vue?vue&type=script&lang=js"
export * from "./Departamentos.vue?vue&type=script&lang=js"
import style0 from "./Departamentos.vue?vue&type=style&index=0&id=7bfa7f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa7f8e",
  null
  
)

export default component.exports